import * as LicensesConstants from "../constants/Licenses";
import {filter, map} from "underscore";

const initialState = {
  collection: [],
  model: {
    serial_key: "",
    license_type: "prescription",
    flavour: "saniq",
    modules: [],
    diaries: [],
    max_amount_devices: null,
    license_provider: {}
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  },
  sorting: {
    sort: 'asc',
    order: 'id',
    query: ''
  },
  isFetching: false,
  isFetchingModel: false,
  isCreating: false
};

export function licenses(state = initialState, action) {
  switch (action.type) {
    case LicensesConstants.FETCH_LICENSE_STARTED:
      return Object.assign({}, state, {isFetchingModel: true, model: initialState.model});
    case LicensesConstants.FETCH_LICENSE_COMPLETED:
      return Object.assign({}, state, {isFetchingModel: false, model: action.license.attributes});
    case LicensesConstants.FETCH_LICENSES_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case LicensesConstants.FETCH_LICENSES_COMPLETED:
      return Object.assign({}, state, {
        collection: action.licenses,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      });
    case LicensesConstants.CREATE_LICENSE_STARTED:
      return Object.assign({}, state, {isCreating: true});
    case LicensesConstants.CREATE_LICENSE_COMPLETED: {
      const newCollection = state.collection.slice();
      newCollection.unshift(action.license);
      return Object.assign({}, state, {isCreating: false, collection: newCollection});
    }
    case LicensesConstants.CREATE_LICENSE_ERROR:
      return Object.assign({}, state, {isCreating: false});
    case LicensesConstants.UPDATE_LICENSE_STARTED:
      return Object.assign({}, state, {isCreating: true});
    case LicensesConstants.UPDATE_LICENSE_COMPLETED: {
      const updatedCollection = map(state.collection, (license) => {
        if (license.attributes.id.toString() === action.license.attributes.id.toString()) {
          return action.license;
        } else {
          return license;
        }
      });

      return Object.assign({}, state, {isCreating: false, collection: updatedCollection});
    }

    case LicensesConstants.DELETE_LICENSE_COMPLETED: {
      const deletedCollection = filter(state.collection, (license) => license.attributes.id.toString() !== action.license.attributes.id.toString());

      return Object.assign({}, state, {collection: deletedCollection});
    }
    default:
      return state;
  }
}
